export const Days: { value: string; translationString: string }[] = [
    {
        value: 'monday',
        translationString: 'time-tracking.generalSettingsPage.monday',
    },
    {
        value: 'tuesday',
        translationString: 'time-tracking.generalSettingsPage.tuesday',
    },
    {
        value: 'wednesday',
        translationString: 'time-tracking.generalSettingsPage.wednesday',
    },
    {
        value: 'thursday',
        translationString: 'time-tracking.generalSettingsPage.thursday',
    },
    {
        value: 'friday',
        translationString: 'time-tracking.generalSettingsPage.friday',
    },
    {
        value: 'saturday',
        translationString: 'time-tracking.generalSettingsPage.saturday',
    },
    {
        value: 'sunday',
        translationString: 'time-tracking.generalSettingsPage.sunday',
    },
];
